import React from 'react';
import AboutUsSection from '../../components/about/AboutUS';
import { useSelector } from 'react-redux';
import ServicesCard from '../../components/home/ServicesCard';
import Quote from '../../components/home/Quote';
import Portfolio from '../../components/home/Portfolio';
import FaqSection from '../../components/about/FAQ';

// Translation object
const translations = {
  en: {  // English
    heading: "Our Services",
    buttonText: "Get In Touch",  // Fixed typo here
  },
  sa: {  // Arabic
    heading: "خدماتنا",
    buttonText: "تواصل معنا",  // More accurate translation for "Get In Touch"
  },
  fr: {  // French
    heading: "Nos Services",
    buttonText: "Contactez-nous",  // More appropriate for "Get In Touch"
  },
  de: {  // German
    heading: "Unsere Dienstleistungen",
    buttonText: "Kontakt aufnehmen",  // Standard for "Get In Touch"
  },
};

const Services = () => {
  const { language } = useSelector((state) => state.language); // from Redux store
  const t = translations[language] || translations.en;

  return (
    <>
      <AboutUsSection
        heading={t.heading}
        buttonText={t.buttonText}
        language={language}
      />
      <ServicesCard/>
      <Quote/>
      <Portfolio/>
      <FaqSection/>
    </>
  );
};

export default Services;
